
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shorthand]/legal/datenschutz",
      function () {
        return require("private-next-pages/[shorthand]/legal/datenschutz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shorthand]/legal/datenschutz"])
      });
    }
  